"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _ListItemLink = _interopRequireDefault(require("../../components/ListItemLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const HeaderListItems = _ref => {
  let {
    onClick,
    items,
    index
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, index > 0 && /*#__PURE__*/_react.default.createElement(_material.Divider, null), _lodash.default.map(items, (_ref2, index) => {
    let {
      onClick: itemOnClick,
      label,
      ...item
    } = _ref2;
    const clickHandler = async event => {
      if (itemOnClick) {
        await itemOnClick(event);
      }
      return onClick(event);
    };
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      dense: true,
      key: index + '-' + _lodash.default.get(item, 'href', 'void')
    }, /*#__PURE__*/_react.default.createElement(_ListItemLink.default, _extends({}, item, {
      onClick: clickHandler
    }), label));
  }));
};
var _default = exports.default = HeaderListItems;